"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Drawer_1 = __importDefault(require("../Drawer"));
var Divider_1 = __importDefault(require("../Divider"));
var List_1 = __importDefault(require("../List"));
var ListItem_1 = __importDefault(require("../ListItem"));
var ListItemText_1 = __importDefault(require("../ListItemText"));
var react_1 = __importStar(require("react"));
var IconButton_1 = __importDefault(require("../IconButton"));
var prism_icons_1 = require("@octanner/prism-icons");
var IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
var styles_1 = require("./styles");
var CultureCloudGradientLogo_1 = __importDefault(require("./CultureCloudGradientLogo"));
var useLayoutLinks_1 = __importStar(require("./hooks/useLayoutLinks"));
var react_i18next_1 = require("react-i18next");
var Layout_1 = __importDefault(require("../context/Layout"));
var prism_utilities_1 = require("@octanner/prism-utilities");
var useEnabledPreferredPronouns_1 = require("./hooks/useEnabledPreferredPronouns");
var identitySearch_1 = require("./identitySearch");
var SingleSearch_1 = __importDefault(require("../SingleSearch"));
var MobileListItems_1 = __importDefault(require("./MobileListItems"));
var MobileDrawer = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = _a.navObj, navOpen = _k.navOpen, setNavOpen = _k.setNavOpen, handleNavigation = _a.handleNavigation, multipleBanksObj = _a.multipleBanksObj, logoutUrl = _a.logoutUrl, handleonChange = _a.handleonChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _l = __read((0, react_1.useState)(''), 2), searchText = _l[0], setSearchText = _l[1];
    var identitySearchQuery = (0, identitySearch_1.useIdentitySearch)(searchText);
    var searchOptions = (identitySearchQuery === null || identitySearchQuery === void 0 ? void 0 : identitySearchQuery.data) || [];
    var _m = __read((0, react_1.useContext)(Layout_1.default), 2), currentIdentityQuery = _m[0], layoutQuery = _m[1];
    var layout = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data;
    var links = (0, useLayoutLinks_1.default)(layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data);
    var mobileLinks = links.menuLinks.filter(function (link) { return link.id !== useLayoutLinks_1.MenuLinks.Logout; });
    var currentIdentity = (_b = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _b === void 0 ? void 0 : _b.currentIdentity;
    var customerUuid = (_c = currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.customer) === null || _c === void 0 ? void 0 : _c.customerUuid;
    var enablePronounData = (0, useEnabledPreferredPronouns_1.useEnabledPreferredPronouns)(customerUuid).data;
    var enablePronouns = (_d = enablePronounData === null || enablePronounData === void 0 ? void 0 : enablePronounData.ccWebPreferredPronouns) === null || _d === void 0 ? void 0 : _d.enabled;
    var fullName = (0, prism_utilities_1.getFullName)(currentIdentity, enablePronouns);
    var avatarSrc = (_e = currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.profile) === null || _e === void 0 ? void 0 : _e.avatar;
    return (react_1.default.createElement(Drawer_1.default, { open: navOpen, onClose: function () { return setNavOpen(false); }, "data-testid": "mobile-drawer" },
        react_1.default.createElement(List_1.default, null,
            react_1.default.createElement(ListItem_1.default, { style: { justifyContent: 'space-between' } },
                react_1.default.createElement(CultureCloudGradientLogo_1.default, { "data-testid": "culturecloud-logo", "aria-label": "Culture Cloud Logo" }),
                react_1.default.createElement(IconButton_1.default, { onClick: function () { return setNavOpen(false); }, "aria-label": "close menu" },
                    react_1.default.createElement(prism_icons_1.Close, null))),
            react_1.default.createElement(ListItem_1.default, null,
                react_1.default.createElement(SingleSearch_1.default, { options: searchOptions, filterOptions: function (option) { return option; }, onChange: handleonChange, "data-testid": "search-cc-header", onInputChange: function (e, _, reason) {
                        if (reason === 'input') {
                            setSearchText(e.target.value);
                        }
                        else if (reason == 'clear') {
                            setSearchText('');
                        }
                    }, onBlur: function () {
                        setNavOpen(false);
                        setSearchText('');
                    }, sx: styles_1.FullWidthSingleSearch, inputValue: searchText, renderOption: function (props, option) { return (react_1.default.createElement("li", __assign({}, props),
                        react_1.default.createElement(IdentityInfo_1.default, { identity: option, color: "primary", isMobile: true }))); } })),
            react_1.default.createElement(MobileListItems_1.default, { links: mobileLinks, handleNavigation: handleNavigation, avatarSrc: avatarSrc, fullName: fullName, multipleBanksObj: multipleBanksObj, identifier: "mobile-list-items" }),
            react_1.default.createElement(MobileListItems_1.default, { links: links.secondaryLinks, handleNavigation: handleNavigation, identifier: "secondary-links" })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(List_1.default, null,
            react_1.default.createElement(MobileListItems_1.default, { links: links.primaryLinks, handleNavigation: handleNavigation, identifier: "primary-links" })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(List_1.default, null,
            react_1.default.createElement(ListItem_1.default, { sx: styles_1.ListItemStyle, className: "fs-unmask", component: "a", href: logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : '/logout', "data-testid": "logout-link", onClick: handleNavigation(logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : '/logout') },
                react_1.default.createElement(ListItemText_1.default, null, t('prism-header:logout')))),
        ((_g = (_f = layout === null || layout === void 0 ? void 0 : layout.theme) === null || _f === void 0 ? void 0 : _f.logo) === null || _g === void 0 ? void 0 : _g.value) && (react_1.default.createElement(styles_1.Logo, null,
            react_1.default.createElement(styles_1.LogoImage, { src: (_j = (_h = layout === null || layout === void 0 ? void 0 : layout.theme) === null || _h === void 0 ? void 0 : _h.logo) === null || _j === void 0 ? void 0 : _j.value })))));
};
exports.default = MobileDrawer;
//# sourceMappingURL=MobileDrawer.js.map